import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { loggedUserSelector } from '../../../../../home/selectors/loggedUser';
import { validTokensSelector } from '../../../../../auth/selectors/token';
import { signinSelector } from '../../../../../auth/selectors/signin';
import LoggedUser from './LoggedUser';

const mapStateToProps = createStructuredSelector({
    loggedUser: loggedUserSelector,
    validTokens: validTokensSelector,
    signinFetching: state => signinSelector(state).fetching,
});

export default connect(mapStateToProps)(LoggedUser);